import { render, staticRenderFns } from "./add-edit-shelves.vue?vue&type=template&id=2a613285&scoped=true"
import script from "./add-edit-shelves.vue?vue&type=script&lang=ts"
export * from "./add-edit-shelves.vue?vue&type=script&lang=ts"
import style0 from "./add-edit-shelves.vue?vue&type=style&index=0&id=2a613285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a613285",
  null
  
)

export default component.exports